(function($){
  if(!$.gnv){
    $.gnv = new Object();
  };

  $.gnv.findOnMap = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.$el.data("gnv.findOnMap", base);

    base.init = function(){
      base.options = $.extend({},$.gnv.findOnMap.defaultOptions, options);

      base.$hotelList = $('#js-hotel-list');
      base.$openMapCta = $('.js-open-map-component');
      base.$closeMapCta = $('.js-close-map-component');
      base.$mapContainer = $('#js-map-div');
      base.$mapComponent = $('.b-map-container');
      base.mapVisible = false;
      base.breakpoint = 769;
      base.locationHash = '#map-results';
      $window = $(window);

      base.$openMapCta.click(function(e){
        e.preventDefault();
        base.hideList();
        base.showMap();
        $('.b-filters__item--histogram').show();
        checkMapVisibility();
        window.location.hash = base.locationHash;
      });

      base.$closeMapCta.click(function(e){
        e.preventDefault();
        base.hideMap();
        base.showList();
        $('.b-filters__item--histogram').hide();
        window.location.hash = '';
      });


      checkMapVisibility();
      $(window).resize(checkMapVisibility);

    };

    base.locationHashChanged = function() {
      if (window.location.hash === '') {
        base.hideMap();
        base.showList();
        $('.b-filters__item--histogram').hide();
      }
    }

    base.hideList = function(){
      base.$hotelList.hide();
    };

    base.showList = function(){
      base.$hotelList.show();
    };

    base.showMap = function(){
      base.$mapContainer.addClass('hotels-map-container--visible');
      $('body').addClass('map-container-visible');
      base.mapVisible = true;
    };

    base.hideMap = function(){
      base.$mapContainer.removeClass('hotels-map-container--visible');
      $('body').removeClass('map-container-visible');
      base.mapVisible = false;
    };

    checkMapVisibility = function(){
      if( base.mapVisible && $window.width() < base.breakpoint ){
        $('.footer').hide();
      };
      if( base.mapVisible && $window.width() > base.breakpoint ){
        $('.footer').show();
      }
    };

    base.init();

    window.onhashchange = base.locationHashChanged;

  };

  $.gnv.findOnMap.defaultOptions = {
  };

  $.fn.gnv_findOnMap = function(options){
    return this.each(function(){
      (new $.gnv.findOnMap(this, options));
    });
  };

})(jQuery);
